import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  configIntegrationApi,
  createInternalSettingsApi,
  deletePhoneNumber,
  dupNewAccount,
  loadSourcesForVoiceAI,
  getInternalSettingsApi,
  getTenantDetailsApi,
  ingestCommunityApi,
  ingestedCommunitiesApiGet,
  onboardCommunitiesApi,
  updatePortal,
  updateRestrictCommunicationApi,
  createCommunityConfigs,
  validatePmsApi,
  verifyCommunityApi,
  verifyRentCafeApi,
  getClientsApi,
  updateClientApi,
  updateClientEmailSettingsApi,
  getCommunitiesApi,
  updateCommunityApi
} from '../util/Apis/selfServe';

export const dupNewUser = createAsyncThunk(
  'selfServe/dupNewUser',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await dupNewAccount(payload);
      showNotification();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateAccount = createAsyncThunk(
  'selfServe/updateAccount',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await updatePortal(payload);
      showNotification();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getTenantDetails = createAsyncThunk(
  'selfServe/getTenantDetails',
  async (params, { rejectWithValue }) => {
    try {
      return await getTenantDetailsApi(params);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateClientEmailSettings = createAsyncThunk(
  'selfServe/updateTenantEmailSettings',
  async ({ clientId, payload }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateClientEmailSettingsApi(clientId, payload);
      dispatch(getTenantDetails(clientId));
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const verifyCommunity = createAsyncThunk(
  'selfServe/verifyCommunity',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await verifyCommunityApi(payload);
      if (showNotification) {
        showNotification();
      }
      return response;
    } catch (err) {
      if (showNotification) {
        showNotification(false, true);
      }
      return rejectWithValue(err);
    }
  }
);
export const ingestCommunity = createAsyncThunk(
  'selfServe/ingestCommunity',
  async (params, { rejectWithValue }) => {
    try {
      return await ingestCommunityApi(params);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const ingestCommunityGet = createAsyncThunk(
  'selfServe/ingestCommunityGet',
  async (params, { rejectWithValue }) => {
    try {
      return await ingestedCommunitiesApiGet(params);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getCommunities = createAsyncThunk(
  'selfServe/getCommunities',
  async ({ tenantId }, { rejectWithValue }) => {
    try {
      const response = await getCommunitiesApi(tenantId);
      return response?.data?.map(c => ({
        _id: c.id,
        name: c.name,
        isLive: c.is_live,
        integrations: c.integrations,
        leadIngestion: c.lead_ingestion,
        isSettingsEnable: c.is_settings_enable,
        preLiveLeadsIngested: c.pre_live_leads_ingested,
        communityPhone: c.community_phone,
        addressId: c.address
          ? {
              _id: c.address.id,
              fullAdd: c.address.full_address,
              stateShort: c.address.state_short,
              postalCode: c.address.postal_code
            }
          : null,
        knockWebhookEnabled: c.knock_webhook_enabled ?? null,
        isCLOProperty: c.is_clo_property
      }));
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateCommunity = createAsyncThunk(
  'selfServe/updateCommunity',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await updateCommunityApi(payload);
      if (showNotification) {
        showNotification('success', true);
      }
      return response;
    } catch (err) {
      if (showNotification) {
        showNotification('failed try again', false);
      }
      return rejectWithValue(err);
    }
  }
);

export const createInternalSettings = createAsyncThunk(
  'selfServe/createInternalSettings',
  async ({ payload }, { rejectWithValue }) => {
    try {
      return await createInternalSettingsApi(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const updateRestrictCommunication = createAsyncThunk(
  'selfServe/updateRestrictCommunication',
  async (payload, { rejectWithValue }) => {
    try {
      return await updateRestrictCommunicationApi(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const verifyRentCafe = createAsyncThunk(
  'selfServe/verifyRentCafe',
  async ({ payload, showNotification }, { rejectWithValue }) => {
    try {
      const response = await verifyRentCafeApi(payload);
      if (showNotification) {
        showNotification();
      }
      return response;
    } catch (err) {
      if (showNotification) {
        showNotification(false, true);
      }
      return rejectWithValue(err);
    }
  }
);

export const getInternalSettings = createAsyncThunk(
  'selfServe/getInternalSettings',
  async (params, { rejectWithValue }) => {
    try {
      return await getInternalSettingsApi(params);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const validatePms = createAsyncThunk(
  'selfServe/validatePms',
  async ({ payload, clientId, errorCheck }, { rejectWithValue }) => {
    try {
      const response = await validatePmsApi(clientId, payload);
      console.log('validatePms response', response);
      if (errorCheck) {
        if (!response?.data?.data) {
          errorCheck(true);
        } else {
          errorCheck(false);
        }
      }
      return response;
    } catch (err) {
      errorCheck(true);
      return rejectWithValue(err);
    }
  }
);

export const validateCrm = createAsyncThunk(
  'selfServe/validateCrm',
  async ({ payload, clientId, errorCheck }, { rejectWithValue }) => {
    try {
      const response = await validatePmsApi(clientId, payload);
      if (errorCheck) {
        errorCheck(!response?.data?.data?.success);
      }
      return response;
    } catch (err) {
      if (errorCheck) errorCheck(true);
      return rejectWithValue(err);
    }
  }
);

export const createCommunityConfigsSelfServe = createAsyncThunk(
  'selfServe/createCommunityConfigs',
  async (
    { payload, showNotification, onboard, ingestCommunitiesOnLoad },
    { rejectWithValue }
  ) => {
    try {
      const response = await createCommunityConfigs(payload);
      if (response?.data) {
        if (showNotification) showNotification(onboard);
        if (ingestCommunitiesOnLoad) ingestCommunitiesOnLoad();
      } else if (showNotification) {
        showNotification(false, true);
      }
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const loadSourcesForVoiceAISelfServe = createAsyncThunk(
  'selfServe/loadSourcesForVoiceAI',
  async (
    { payload, showNotification, onboard, ingestCommunitiesOnLoad },
    { rejectWithValue }
  ) => {
    try {
      const response = await loadSourcesForVoiceAI(payload);
      if (response?.data) {
        if (showNotification) showNotification(onboard);
        if (ingestCommunitiesOnLoad) ingestCommunitiesOnLoad();
      } else if (showNotification) {
        showNotification(false, true);
      }
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const onboardCommunities = createAsyncThunk(
  'selfserve/onboardCommunities',
  async (
    { tenantId, communityIds, ingestCommunitiesOnLoad },
    { rejectWithValue }
  ) => {
    try {
      const response = await onboardCommunitiesApi({
        client_id: tenantId,
        community_ids: communityIds
      });
      if (ingestCommunitiesOnLoad) {
        ingestCommunitiesOnLoad({
          upload: true,
          success: true,
          msg: 'successFully onboarded'
        });
      }
      return response;
    } catch (err) {
      if (ingestCommunitiesOnLoad) {
        ingestCommunitiesOnLoad({
          upload: true,
          success: false,
          msg: 'onboard failed try again'
        });
      }
      return rejectWithValue(err);
    }
  }
);
export const configIntegration = createAsyncThunk(
  'selfserve/configIntegration',
  async ({ payload }, { rejectWithValue }) => {
    try {
      return await configIntegrationApi(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const deletePhoneNumberApi = createAsyncThunk(
  'selfserve/deletePhoneNumber',
  async ({ payload, callTenenantApi }, { rejectWithValue }) => {
    try {
      const response = await deletePhoneNumber(payload);
      if (response) {
        callTenenantApi();
      }
      return response;
    } catch (err) {
      callTenenantApi();
      return rejectWithValue(err);
    }
  }
);

export const updateClientList = payload => ({
  type: `updateClientList`,
  payload
});

export const getClients = createAsyncThunk(
  'selfServe/getClients',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getClientsApi();
      return response?.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateClient = createAsyncThunk(
  'selfServe/updateClient',
  async ({ clientId, data }, { rejectWithValue }) => {
    try {
      const response = await updateClientApi(clientId, data);
      return response?.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
